import React,{useState,useEffect,useRef} from 'react';
import { Container,Col,Row,Form } from 'react-bootstrap';
import { TablaPagoBonos, TablaReportes } from '../../Components/Components';

export const Reportes = ({state,updateState}) => {
  const {openMenu} = state;
  const ref = useRef(null);
  const [isSticky, setSticky] = useState(false);
  const handleScroll = () => {
    const winScroll = document.body.scrollTop || document.documentElement.scrollTop
    const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    const scrolled = winScroll / height;
    scrolled>0 ? setSticky(true) : setSticky(false) 

  };
  useEffect(() => {
    
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', () => handleScroll);
    };
  }, [])
  
  return (
    <div className={`ws_content_wrapper ${(!openMenu) ? 'wrapper_close' : ''}`}>
      <div className="ws_content_header ws_pl_0 ws_pr_0 mb-5">
        <Container fluid className={`ws_header_fixed ${isSticky ? 'shadow' : ''} mt-st-7`} ref={ref} style={{ borderBottom: '1px solid #ccc' }}>
          <Row>
            <Col className="mb-2" xs={12} md={3}>
              <h1 className="ws_title_header">Reportes</h1>
            </Col>
          </Row>
        </Container>
        <Container fluid className="mt-5">
          <Row>
            <TablaReportes initState={state} updateState={updateState} />
            <TablaPagoBonos initState={state} updateState={updateState} />
          </Row>
        </Container>

      </div>
    </div>
  )
}